import { useAppSelector } from "@app/hooks";
import { appNavigationFundsSelector } from "@app/store/selectors";

export const useFundsDataValidation = () => {
  const funds = useAppSelector(appNavigationFundsSelector);
  const isFundAvalable = funds.length > 0 ? true : false;

  return isFundAvalable;
};
